module.exports = __webpack_public_path__ + "img/play-store.5af2fc84.webp";